export function escapeHtml(htmlString) {
	if (!htmlString) return htmlString;
	return htmlString
		.replaceAll(/&/g, "&amp;")
		.replaceAll(/</g, "&lt;")
		.replaceAll(/>/g, "&gt;")
		.replaceAll(/"/g, "&quot;")
		.replaceAll(/'/g, "&#39;");
}

export function unEscapeHtml(htmlString) {
	if (!htmlString) return htmlString;
	htmlString = htmlString.replaceAll(/&lt;/g, "<");
	htmlString = htmlString.replaceAll(/&gt;/g, ">");
	htmlString = htmlString.replaceAll(/&quot;/g, '"');
	htmlString = htmlString.replaceAll(/&#39;/g, "'");
	htmlString = htmlString.replaceAll(/&amp;/g, "&");
	return htmlString;
}

export function cloneDeep<T>(value: T): T {
	if (typeof value !== "object" || value === null) {
		// Return the value if value is not an object or is null
		return value;
	}

	if (value instanceof Date) {
		// Handle Date (deep clone dates)
		return new Date(value.getTime()) as any;
	}

	if (Array.isArray(value)) {
		// Handle Array (iterate and deep clone each item)
		const copy = [] as any[];
		value.forEach((item, index) => {
			copy[index] = cloneDeep(item);
		});
		return copy as any;
	}

	if (value instanceof Object) {
		// Handle Object (iterate and deep clone each property)
		const copy = {} as { [key: string]: any };
		Object.keys(value).forEach((key) => {
			copy[key] = cloneDeep((value as { [key: string]: any })[key]);
		});
		return copy as T;
	}

	// If the type is not specifically handled above, just return the value
	// This line might never be reached with the current TypeScript implementation
	// but it's a good safety measure for future extensions.
	return value;
}
